export const DANGER_TIME_RANGE = 7
export const WARNING_TIME_RANGE = 14
export const COMFORTABLE_TIME_RANGE = 30
